import React from 'react';
import affiliate from '../affiliate-banner.jpg';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
function Affiliate(){
   
    return (
        <main className="mtopcon normal-mt-sctn">
            <div className="container">
                
                <div className="row mb-4 p-2 text-center">
                    <h2><b>Earn by Referring Sellers</b></h2>
                    <p className='font9'>Join Kadhr's Affiliate Program and get paid for every seller you refer who subscribes.</p>
                    
                    <div className='affiliate-img br-18 mt-4 mb-4'>
                        <img src={affiliate}  className="h-100 br-18"/>
                    </div>
                    <h1 className='font-bold'>Coming Soon....</h1>
                </div>
            </div>
        </main>
    )
}

export default Affiliate;
